module.exports = __webpack_public_path__ + "static/media/GLOSSTAD.5ca74fbf.txt";